import { useState } from 'react';
import { ConfirmModal } from './ConfirmModal';

// A quiet "Leave game" link, for the bottom of the live-round screens. (It used
// to be a floating 🚪 on every game screen, which sat on top of the question.)
export function LeaveGame({ onLeave }: { onLeave: () => void }) {
  const [confirming, setConfirming] = useState(false);
  return (
    <>
      <button className="text-link" onClick={() => setConfirming(true)}>Leave game</button>
      <ConfirmModal
        open={confirming}
        title="Leave the quiz?"
        message="The others will see that you left."
        confirmLabel="Leave"
        cancelLabel="Stay"
        onConfirm={onLeave}
        onCancel={() => setConfirming(false)}
      />
    </>
  );
}
